import styled, { css } from "styled-components";

export const SIDEBAR_WIDTH = 232;
export const SIDEBAR_COLLAPSED_WIDTH = 72;
export const MOBILE_BREAKPOINT = 1024;

export const Aside = styled.aside<{ $open: boolean; $collapsed: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  height: 100dvh;
  width: ${({ $collapsed }) => ($collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH)}px;
  background: #ffffff;
  border-right: 1px solid #e7e0d8;
  display: flex;
  flex-direction: column;
  padding: 18px ${({ $collapsed }) => ($collapsed ? 12 : 16)}px 16px;
  box-sizing: border-box;
  z-index: 60;
  transition: width 0.2s ease, padding 0.2s ease;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    width: ${SIDEBAR_WIDTH}px;
    padding: 18px 16px calc(16px + env(safe-area-inset-bottom));
    transform: translateX(${({ $open }) => ($open ? "0" : "-100%")});
    transition: transform 0.25s ease;
    box-shadow: ${({ $open }) => ($open ? "0 0 40px rgba(0,0,0,0.18)" : "none")};
  }
`;

export const Backdrop = styled.div<{ $open: boolean }>`
  display: none;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: ${({ $open }) => ($open ? "block" : "none")};
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 55;
  }
`;

export const LogoRow = styled.div<{ $collapsed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $collapsed }) => ($collapsed ? "center" : "space-between")};
  flex-direction: ${({ $collapsed }) => ($collapsed ? "column" : "row")};
  gap: 10px;
  padding: 0 ${({ $collapsed }) => ($collapsed ? 0 : 8)}px 18px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 0 8px 18px;
  }
`;

export const LogoImg = styled.img`
  height: 26px;
  width: auto;
`;

export const LogoMark = styled.img`
  height: 36px;
  width: 36px;
  border-radius: 50%;
`;

export const CollapseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #9a8e84;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: #f2efe9;
    color: #111111;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: none;
  }
`;

export const NavList = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
`;

const itemBase = css<{ $collapsed?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $collapsed }) => ($collapsed ? "center" : "flex-start")};
  gap: 12px;
  width: 100%;
  border: none;
  font-family: 'Aileron', 'Poppins', sans-serif;
  font-size: 14px;
  text-align: left;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s, opacity 0.15s;

  svg {
    flex-shrink: 0;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    justify-content: flex-start;
  }
`;

export const NavItem = styled.button<{ $active: boolean; $collapsed: boolean }>`
  ${itemBase}
  background: ${({ $active }) => ($active ? "#f2efe9" : "transparent")};
  color: ${({ $active }) => ($active ? "#111111" : "#6b6259")};
  font-weight: ${({ $active }) => ($active ? 700 : 500)};

  &:hover {
    background: #f2efe9;
    color: #111111;
  }
`;

export const ItemLabel = styled.span<{ $collapsed: boolean }>`
  display: ${({ $collapsed }) => ($collapsed ? "none" : "inline")};

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: inline;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid #eee5db;
  padding-top: 12px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FooterButton = styled.button<{ $collapsed: boolean }>`
  ${itemBase}
  background: transparent;
  color: #6b6259;
  font-weight: 500;

  &:hover {
    background: #f2efe9;
    color: #111111;
  }
`;

export const LogoutButton = styled.button<{ $collapsed: boolean }>`
  ${itemBase}
  background: #111111;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;

  &:hover {
    opacity: 0.88;
  }
`;
